import { apiClient } from '@api'

/**
 * Company Settings Service
 *
 * Service layer for managing company settings (self-service)
 * Provides methods for Company Admin to manage their own company profile
 */
class CompanySettingsService {
	/**
	 * Get current company settings
	 * Uses authenticated user's company context from JWT token
	 * @returns {Promise<Object>} Company data with package details
	 */
	async getSettings() {
		return await apiClient.get('/company-settings')
	}

	/**
	 * Update company profile
	 * @param {Object} data - Company data to update
	 * @param {string} data.name - Company name
	 * @param {string} data.phone - Company phone
	 * @param {string} data.website - Company website
	 * @param {string} data.address - Street address
	 * @param {string} data.city - City
	 * @param {string} data.state - State/Province
	 * @param {string} data.country - Country
	 * @param {string} data.postal_code - Postal code
	 * @param {string} data.industry - Industry sector
	 * @param {string} data.company_size - Company size range
	 * @param {Object} data.settings - Additional settings (JSON)
	 * @returns {Promise<Object>} Updated company data
	 */
	async updateSettings(data) {
		return await apiClient.put('/company-settings', data)
	}
}

// Export singleton instance
export const companySettingsService = new CompanySettingsService()
export default companySettingsService
